exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".JoFQz{margin-top:20px}._3QNtp{width:200px}._2iDdE{list-style:none}._2fQe9{font-size:11px;color:inherit;text-decoration:none;margin-top:0;margin-bottom:1em;white-space:nowrap;overflow:hidden;display:block}._1LE5p{cursor:pointer;text-decoration:none}._1LE5p,._2XVd2{padding:10px;font-size:14px;font-weight:700;display:inline-block;color:hsla(0,0%,100%,.5)}.wcDf5{color:#dedede!important;font-size:12px}._3oo16{color:rgba(64,64,64,.98);font-size:12px;font-weight:700}._35FVL{display:block;padding-left:0;margin-left:-6px;font-size:12px;cursor:auto}.r4Dcm{cursor:pointer}._1gtiU{color:hsla(0,0%,100%,.5)!important}._1mQCi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports
exports.locals = {
	"root": "JoFQz",
	"column": "_3QNtp",
	"item": "_2iDdE",
	"link": "_2fQe9",
	"resetLocationLink": "_1LE5p",
	"resetLocationText": "_2XVd2",
	"selLocation": "wcDf5",
	"disabledCity": "_3oo16",
	"curentBreadCrumbs": "_35FVL",
	"cursorPointer": "r4Dcm",
	"hideHover": "_1gtiU",
	"breadCrumbsBlock": "_1mQCi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Footer/ColumnList/ColumnList.css
// module id = 1377
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46